// extracted by mini-css-extract-plugin
export var Container = "BooksPage-module--Container--fYWdo";
export var SmallText = "BooksPage-module--SmallText--34fc3";
export var Header = "BooksPage-module--Header--2jyla";